// re-export so it's under src/hooks
import { useAppState } from "src/state";

export default useAppState;
